/*
    Vanilla Functions
 */

/**
 * Extends the Array by a contains function
 *
 * @param array (required)
 * @param obj (required)
 * @returns {boolean} true if Array contains obj
 */
arrayContains = function (array, obj) {
    var i = array.length;
    while (i--) {
        if (array[i] === obj) {
            return true;
        }
    }
    return false;
};

/**
 * Decodes html string
 *
 * @param input text to decode
 * @returns html decoded
 */
function htmlDecode(input) {
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}

/**
 * Parsing of Double (Float). Returns a defaultValue if impossible
 *
 * @param value
 * @param defaultValue
 * @returns parsed value or default value
 */
function parseDouble(value, defaultValue) {
    var parsedValue = parseFloat(value);
    if (isNaN(parsedValue)) {
        return defaultValue;
    }
    return parsedValue;
}

/**
 * Parsing of Integer. Returns a defaultValue if impossible
 *
 * @param value
 * @param defaultValue
 * @returns parsed value or default value
 */
function parseInteger(value, defaultValue) {
    var parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue)) {
        return defaultValue;
    }
    return parsedValue;
}


/*
    JQuery Functions
 */

/**
 * Performs a scroll action to the target
 * @param $target (required)
 * @param force - forces the scrolling even the element is already visible in the area
 */
function scrollToTarget($target, force) {
    force = force || false;

    var $html = $('html,body');
    var currentPosition = $html.scrollTop(),
        windowHeight = $(window).height(),
        targetPosition = $target.offset().top - 20;

    if (force || (targetPosition < currentPosition || targetPosition > currentPosition + windowHeight)) {
        $html.animate({
            scrollTop: targetPosition
        }, 500);
    }
    return false;
}


/**
 * Reindex all entries to prevent unused index numbers
 * @param $form all the rows for indexing
 * @param path the path to reindex (default: 'updateForms')
 */
function reindexEntries($form, path) {
    var index = 0;
    path = path || 'entries';

    $form.each(function () {
        var $inputs = $(this).find('[name*="' + path + '["]');

        if ($inputs.length) {
            $inputs.each(function () {
                var $input = $(this);
                $input.attr('name', $input.attr('name').replace(new RegExp(path + '\\[.*?]', 'g'), path + '[' + index + ']'));
            });

            index++;
        }
    });
}